import Generic from "../component/Generic";
import { ReactComponent as dashboard } from "../assets/icons/dashboard.svg";
import { ReactComponent as user } from "../assets/icons/user.svg";
import { ReactComponent as home } from "../assets/icons/home.svg";
import { ReactComponent as plus } from "../assets/icons/plus-dashed.svg";
import { ReactComponent as heart } from "../assets/icons/heart.svg";
import { ReactComponent as search } from "../assets/icons/search.svg";
import { ReactComponent as invoices } from "../assets/icons/invoice.svg";
import { ReactComponent as msg } from "../assets/icons/msg.svg";
import { ReactComponent as logout } from "../assets/icons/logout.svg";
import DashboardComponent from "../component/Sell/Dashboardd";
import InBoxing from "../component/Sell/Dashboardd/InBoxing";
import Favorites from "../component/Sell/Dashboardd/Favorites";
import NewProperty from "../component/Sell/Dashboardd/NewProperty";
import MyPropComponent from "../component/Sell/Dashboardd/MyProperties";
import MyProfile from "../component/Sell/Dashboardd/MyProfile";
export const Dashboard = [
  {
    id: 1,
    title: "Dashboard",
    pathname: "/sell/dashboard",
    Component: DashboardComponent,
    child: [],
    Icon: dashboard,
    role: ["admin"],
  },
  {
    id: 2,
    title: "My Profile",
    pathname: "/my-profile",
    Component: MyProfile,
    child: [],
    Icon: user,
    role: ["admin"],
  },
  {
    id: 3,
    title: "My Properties List",
    pathname: "/my-properties-list",
    Component: MyPropComponent,
    child: [],
    Icon: home,
    role: ["admin"],
  },
  {
    id: 4,
    title: "Add New Property",
    pathname: "/add-new-property",
    Component: NewProperty,
    child: [],
    Icon: plus,
    role: ["admin"],
  },
  {
    id: 5,
    title: "Favorites",
    pathname: "/favorites",
    Component: Favorites,
    child: [],
    Icon: heart,
    role: ["admin"],
  },
  {
    id: 6,
    title: "Saved Searches",
    pathname: "/saved-searches",
    Component: Generic,
    child: [],
    Icon: search,
    role: ["admin"],
  },
  {
    id: 7,
    title: "My Invoices",
    pathname: "/my-invoices",
    Component: Generic,
    child: [],
    Icon: invoices,
    role: ["admin"],
  },
  {
    id: 8,
    title: "Inbox",
    pathname: "/inbox",
    Component: InBoxing,
    child: [],
    Icon: msg,
    role: ["admin"],
  },
  {
    id: 9,
    title: "Logout",
    Component: Generic,
    Icon: logout,
    pathname: "/register-as-realtor",
  },
];
